import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
export function StickyCTA() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling past hero (approx 600px)
      if (window.scrollY > 600) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <AnimatePresence data-id="element-246">
      {isVisible && <motion.div initial={{
      y: 100
    }} animate={{
      y: 0
    }} exit={{
      y: 100
    }} className="fixed bottom-0 left-0 w-full bg-brand-dark/95 backdrop-blur-md border-t border-gray-800 p-4 z-50 md:hidden shadow-[0_-10px_30px_rgba(0,0,0,0.5)]" data-id="element-247">
          <a href="#pricing" className="flex items-center justify-center w-full bg-brand-pink text-white font-display text-lg py-4 rounded-xl shadow-[0_0_15px_rgba(255,59,92,0.3)]" data-id="element-248">
            💥 QUIERO COMENZAR AHORA
          </a>
        </motion.div>}
    </AnimatePresence>;
}